import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './core/config.service';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(private http: HttpClient,private configService: ConfigService) { }

  uploadFileToStorage(file: File, nameTypeUser: string, isfournise: string) {
    const formData: FormData = new FormData();
    formData.append('UploadFiles', file);
    return this.http.post(`${this.configService.config.backendUri}/Upload/Upload?nameTypeUser=${nameTypeUser}&isfourniseur=${isfournise}`, formData, {
      reportProgress: true,
      responseType: 'text'
    });
  }
}
